import { Link, Meta } from './Pagination';

export interface ProductFormData {
  name: string;
  offer_name?: string;
  description: string;
  email_support: string;
  phone_prefix: string;
  whatsapp_support: string;
  image: File | null;
  sales_page: string;
  thankyou_url?: string | null;
  page_url?: string;
  support_url?: string | null;
  privacy_terms_url?: string | null;
  product_delivery: string;
  offer_price: number;
  offer_payment_type: string;
  offer_currency: string;
  offer_recurring_interval: string;
  offer_trial_enabled?: boolean;
  offer_trial_mode?: string;
  offer_trial_price?: number | null;
  offer_trial_interval?: string;

  product_type: string;
  category_id: string;
  sku?: string;
  product_url: string;
  product_email: string;
  product_password: string;
  product_extras?: string;
  category_type?: string;
  refund_deadline_days?: number;
}

export interface EditProductRequest extends Omit<ProductFormData, 'product_type'> {
  id?: string;
  status: ProductStatus;
  product_delivery: string;
  refund_deadline_days?: number;
  refund_deadline_days_min?: number;
  refund_deadline_days_max?: number;
  refund_deadline_days_options?: number[];
  product_type?: string;
}

export interface ImageType {
  id: string;
  url: string;
}

export enum ProductRole {
  PRODUCER = 'producer',
  COPRODUCER = 'coproducer',
  AFFILIATE = 'affiliate',
}

export enum ProductStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  BLOCKED = 'blocked',
  REVISION = 'revision',
  ANALYSIS = 'analysis',
  IN_REVIEW = 'in_review',
}


export interface ProductDetailsResponse {
  secret_order_bump: boolean;
  id: string;
  name: string;
  description: string;
  email_support: string;
  phone_prefix: string;
  whatsapp_support: string;
  sales_page: string;
  thankyou_url?: string | null;
  support_url?: string;
  privacy_terms_url?: string;
  status: ProductStatus;
  images: ImageType[];
  category_id: string;
  category: {
    id: string;
    name: string;
    name_translations?: Record<string, string>;
    label: string;
    type: string;
  };
  relationship: {
    role: ProductRole;
  };
  product_url?: string;
  product_email?: string;
  product_password?: string;
  product_extras?: string;
  product_delivery: string;
  refund_deadline_days?: number | null;
}

export interface ProductResponse {
  data: ProductDetailsResponse[];
  meta: Meta;
  links: Link;
}

export interface DeliverablesResponse {
  id: string;
  path: string;
  disk: string;
  visibility: 'public' | 'private';
  name: string;
  original_name: string;
  original_extension: string;
  extension: string;
  mime_type: string;
  url: string;
  collection: string;
  size_formatted: string;
  size: number;
}

export type RegulatoryDocumentType =
  | 'contract'
  | 'coa'
  | 'label'
  | 'manufacturing_license'
  | 'other';

export interface RegulatoryDocumentFile {
  id: string;
  path: string;
  disk: string;
  visibility: string;
  size: number;
  size_formatted: string;
  name: string;
  original_name: string;
  original_extension: string;
  extension: string;
  mime_type: string;
  url: string;
  collection: string;
}

export interface RegulatoryDocumentResponse {
  id: number;
  document_name: string | null;
  document_type: RegulatoryDocumentType | string | null;
  note: string | null;
  status: string;
  internal_note: string | null;
  analyzed_at: string | null;
  file: RegulatoryDocumentFile;
  created_at: string;
}

export interface PendingRegulatoryDocument {
  localId: string;
  file: File;
  name: string;
  type: RegulatoryDocumentType | '';
  notes: string;
}

export interface RegulatoryDocumentUploadItem {
  file: File;
  document_name: string;
  document_type?: string;
  note?: string;
}
